import { Airport } from './Airport'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import React from 'react'
import { Link } from 'react-router-dom'
import { Tooltip } from '@mui/material'

interface Props {
  airports: Airport[]
  selectedAirportIcao?: string
}

const AirportsList = ({ airports, selectedAirportIcao }: Props) => {
  return (
    <Box sx={{ width: '13rem', minWidth: '13rem', bgcolor: 'background.paper' }}>
      <List component="nav">
        {airports.map((airport) => (
          <Tooltip key={airport.icao} title={`${airport.icao} - ${airport.name}`} placement="left" enterDelay={1000}>
            <ListItemButton
              key={airport.icao}
              selected={airport.icao === selectedAirportIcao}
              {...{ component: Link, to: airport.icao }}
            >
              <ListItemText primary={`${airport.name}`} />
            </ListItemButton>
          </Tooltip>
        ))}
      </List>
    </Box>
  )
}

export default AirportsList
